<script>
import BrandSelect from "@/components/components/BrandSelect.vue";
import Multiselect from "vue-multiselect";

export default {
  name: "MassChangeBrand",
  components: {Multiselect, BrandSelect},
  data() {
    return {
      brands: [],
      brand: null,
      isLoad: false,
      showPriceKp: {
        name: 'show_price_kp',
        value: true,
      },
      fields: [
        {
          name: 'show_price_kp',
          value: true,
          type: 'boolean'
        },
        {
          name: 'is_ready',
          value: true,
          type: 'boolean'
        },
        {
          name: 'is_synchronized',
          value: true,
          type: 'boolean'
        },
        {
          name: 'is_published',
          value: true,
          type: 'boolean'
        },
        {
          name: 'processed',
          value: true,
          type: 'boolean'
        },
        {
          name: 'currency',
          value: 'EUR',
          type: 'text'
        },
        {
          name: 'seo_flag',
          value: true,
          type: 'boolean'
        },
        {
          name: 'is_online',
          value: true,
          type: 'boolean'
        },
        {
          name: 'is_shop',
          value: true,
          type: 'boolean'
        }
      ],
      field: null
    }
  },
  computed: {
    fieldNameModel: {
      get: function () {
        return this.fields.find((item) => item.name === this.field.name)
      },
      set: function (value) {
        this.field.name = value.name
      }
    }
  },
  methods: {
    brandsChange(brand) {
      this.brand = brand;
    },
    async save() {
      if (!this.brand) {
        await this.$bvModal.msgBoxOk('Выберите бренд!')
        return false
      }
      let filters = {
        brandId: this.brand.id
      }
      var th = this
      let formData = new FormData();

      formData.append('filters', JSON.stringify(filters));
      formData.append('field', JSON.stringify(this.field));

      this.isLoad = true;
      this.$store.dispatch('SEND_POST', {
        url: '/goods-mass-change-field',
        parameter: formData,
        config: {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        },
        th: th,
        getSuccessResponse: (data) => {
          console.log(11, data)
        },
        getResponse: () => {
          th.isLoad = false;
        },
        getHandleError: (errorInfo) => {
          th.$store.commit('setErrorText', errorInfo);
          th.$bvModal.show('errorResponse');
        }
      });
    },
  },
  created() {
    this.field = this.fields[0]
  }
}
</script>

<template>
  <b-row>
    <b-col>
      <b-card>
        <b-card-header>
          Массовое изменение значения для поля {{field.name}}
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col cols="4">
              <b-form-group
                  id="input-group-1"
                  label="Бренд"
                  label-for="input-1"
                  description="Выбрать бренд у товаров которого изменится поле"
              >
                <brand-select
                    id="input-1"
                    class="edit-cell"
                    type="text"
                    size="sm"
                    v-bind:initBrands="[]"
                    v-bind:brands-change="brandsChange"
                    v-bind:multiple="false"
                ></brand-select>
              </b-form-group>
            </b-col>
            <b-col cols="8">
              <b-row>
                <b-col cols="4">
                  <b-form-group
                      id="input-group-1"
                      label="Поле"
                      label-for="input-1"
                      description="Название поля, которое будет изменено"
                  >
                    <multiselect
                        v-model="field"
                        :options="fields"
                        track-by="name"
                        label="name"
                        :show-labels="false"
                        :clear-on-select="false"
                    ></multiselect>
                  </b-form-group>
                </b-col>
                <b-col cols="4">
                  <b-form-group
                      id="input-group-1"
                      label="Значение"
                      label-for="input-1"
                      description="Значение поля, которое будет записано"
                  >
                    <template v-if="field && field.type==='boolean'">
                      <b-form-checkbox
                          v-model="field.value"
                          size="sm"
                          class="left height-block-40"
                      >
                        {{field.name}}
                      </b-form-checkbox>
                    </template>
                    <template v-if="field && field.type==='text'">
                      <input type="text" class="form-control height-block-40" v-model="field.value">
                    </template>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card-body>
        <b-card-footer>
          <b-btn variant="primary" @click="save" :disabled="isLoad">
            <b-spinner small v-if="isLoad"></b-spinner>
            <span class="sr-only" v-if="isLoad">Loading...</span>
            Изменить
          </b-btn>
        </b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<style scoped>
  .right{
    text-align: right;
  }
  .left{
    text-align: left;
  }
  .height-block-40{
    height: 40px;
  }
</style>